/* eslint-disable max-len */

import {
  shippingIcon,
  qualityIcon,
  returnBoxIcon,
  newIcon,
  instagramPost1,
  instagramPost2,
  instagramPost3,
  instagramPost4,
  instagramPost5,
  instagramPost6,
  instagramPost7,
  instagramPost8,
  instagramPost9,
} from '../assets';

export const benefits = [
  {
    id: 'b1',
    title: 'FREE SHIPPING',
    description: 'Minimal Purchase IDR 10.000',
    image: shippingIcon,
  },
  {
    id: 'b2',
    title: 'HIGH QUALITY',
    description: 'Self Manufactured',
    image: qualityIcon,
  },
  {
    id: 'b3',
    title: 'EXCHANGE',
    description: '7 Days Exchange',
    image: returnBoxIcon,
  },
  {
    id: 'b4',
    title: 'NEW COLLECTION',
    description: 'Every 2 Weeks',
    image: newIcon,
  },
];

export const informations = [
  {
    id: 'i1',
    title: 'ESSENTIAL FOR EVERY WOMAN',
    url: 'https://lookboutiquestore.com/essential-for-every-woman/',
  },
  {
    id: 'i2',
    title: 'ABOUT US',
    url: 'https://lookboutiquestore.com/about-us/',
  },
  {
    id: 'i3',
    title: 'CONTACT',
    url: 'https://lookboutiquestore.com/lbs-contact/',
  },
  {
    id: 'i4',
    title: 'PROMOTION',
    url: 'https://lookboutiquestore.com/promotion/',
  },
  {
    id: 'i5',
    title: 'CAREER',
    url: 'https://lookboutiquestore.com/lbs-career/',
  },
  {
    id: 'i6',
    title: 'SHIPPING INFO',
    url: 'https://lookboutiquestore.com/shipping-info/',
  },
];

export const helps = [
  {
    id: 'h1',
    title: 'HOW TO ORDER',
    url: 'https://lookboutiquestore.com/how-to-order/',
  },
  {
    id: 'h2',
    title: 'PAYMENT CONFIRMATION',
    url: 'https://lookboutiquestore.com/konfirmasi/',
  },
  {
    id: 'h3',
    title: 'TERMS & CONDITION',
    url: 'https://lookboutiquestore.com/term-and-condition/',
  },
  {
    id: 'h4',
    title: 'TRACK YOUR ORDER',
    url: 'https://lookboutiquestore.com/order-tracking/',
  },
  {
    id: 'h5',
    title: 'FAQ',
    url: 'https://lookboutiquestore.com/faq/',
  },
];

export const posts = [
  {
    id: 'p1',
    image: instagramPost1,
    url: 'https://www.instagram.com/p/Ct-5uNzupWv/',
  },
  {
    id: 'p2',
    image: instagramPost2,
    url: 'https://www.instagram.com/p/Ct-fGqoyaOm/',
  },
  {
    id: 'p3',
    image: instagramPost3,
    url: 'https://www.instagram.com/p/Ct8yJjjvrcl/',
  },
  {
    id: 'p4',
    image: instagramPost4,
    url: 'https://www.instagram.com/p/Ct8XNbIStXn/',
  },
  {
    id: 'p5',
    image: instagramPost5,
    url: 'https://www.instagram.com/p/Ct7-UEnSdND/',
  },
  {
    id: 'p6',
    image: instagramPost6,
    url: 'https://www.instagram.com/p/Ct6Lfn4xtzS/',
  },
  {
    id: 'p7',
    image: instagramPost7,
    url: 'https://www.instagram.com/p/Ct5W3ZGyYuu/',
  },
  {
    id: 'p8',
    image: instagramPost8,
    url: 'https://www.instagram.com/p/Ct3t0kRLVqT/',
  },
  {
    id: 'p9',
    image: instagramPost9,
    url: 'https://www.instagram.com/p/Ct3QCK1SeIF/',
  },
];
